export const toLocalISO = (value) => {
  if (!value) return "N/A";

  try {
    let date;

    // If Unix timestamp in SECONDS → convert to ms
    if (!isNaN(value) && value.toString().length === 10) {
      date = new Date(value * 1000);
    } else {
      date = new Date(value);
    }

    if (isNaN(date.getTime())) return value;

    // Format in local timezone, ISO-like (YYYY-MM-DD HH:mm:ss)
    return date.toLocaleString("sv-SE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  } catch (err) {
    return value;
  }
};


/**
 * IANA zone id of the viewer's browser (e.g. "Asia/Kolkata"). Used to prefill
 * the timezone picker when scheduling something for a future local time —
 * the value actually sent to the backend, not just a display hint.
 */
export const getBrowserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (err) {
    return "UTC";
  }
};

export function convertUtcToLocal(utcString) {
    const date = new Date(utcString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }